import {TriggerScopeType} from '../../../generated/graphql';
import {DEFAULT_LAUNCH_PROJECT_NAME} from '../../../pages/EntityLaunchPage';
import {TriggerRootFilter} from './TriggerEventConfiguration';
import {EventTriggeringConditionType} from './TriggerEventTypes';

export type OptionType = {
  label: string;
  value: string;
};

type TriggerDescriptionInput = {
  jobName: string;
  jobAlias: string;
  eventType?: EventTriggeringConditionType;
  triggerScopeType?: TriggerScopeType;
  entityName?: string;
  projectName?: string;
  artifactCollectionName?: string;
  filters?: TriggerRootFilter;
};

// Derive default trigger 'description' based on event type and user inputs
export const getDefaultTriggerDescription = (
  input: TriggerDescriptionInput
) => {
  const stringStart = `Run "${input.jobName}:${input.jobAlias}" whenever `;
  let stringEnd = '';
  if (input.eventType === EventTriggeringConditionType.LinkModel) {
    stringEnd = `a new model version is linked to "${input.artifactCollectionName}".`;
  } else if (input.eventType === EventTriggeringConditionType.CreateArtifact) {
    stringEnd = `a new version of "${input.artifactCollectionName}" is created.`;
  } else if (
    input.eventType === EventTriggeringConditionType.AddArtifactAlias ||
    input.eventType === EventTriggeringConditionType.UpdateArtifactAlias
  ) {
    // In the case of the AddAlias or UpdateAlias trigger event, the first filter gives us the alias name
    const alias = input.filters?.filters[0]?.filters[0]?.value;
    if (input.eventType === EventTriggeringConditionType.AddArtifactAlias) {
      if (input.triggerScopeType === TriggerScopeType.ArtifactCollection) {
        stringEnd = `the alias "${alias}" is added to any version in the collection "${input.artifactCollectionName}"`;
      } else {
        if (input.projectName === DEFAULT_LAUNCH_PROJECT_NAME) {
          // Use entity name
          stringEnd = `the alias "${alias}" is added to any artifact in the entity "${input.entityName}'s" model registry.`;
        } else {
          stringEnd = `the alias "${alias}" is added to any artifact in the project "${input.projectName}".`;
        }
      }
    } else {
      if (input.triggerScopeType === TriggerScopeType.ArtifactCollection) {
        stringEnd = `the alias of any version in the collection "${input.artifactCollectionName}" is updated to ${alias}`;
      } else {
        if (input.projectName === DEFAULT_LAUNCH_PROJECT_NAME) {
          // Use entity name
          stringEnd = `the alias of any artifact in the entity "${input.entityName}'s" model registry is updated to ${alias}.`;
        } else {
          stringEnd = `the alias of any artifact in the project "${input.projectName}" is updated to ${alias}.`;
        }
      }
    }
  } else {
    return '';
  }
  return stringStart + stringEnd;
};
